import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Text, Title } from '@siftscience/focus-components/text'
import { Checkbox } from '@siftscience/focus-components/checkbox'
import { Button } from '@siftscience/focus-components/button'
import { Delete } from '@siftscience/focus-components/icons/Delete'

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: '#fff',
    display: 'flex',
    position: 'fixed',
    width: '462px',
    height: '72px',
    borderRadius: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    bottom: '48px',
    left: '50%',
    transform: 'translate(-50%, 0)'
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  button: {
    display: 'flex',
    alignItems: 'center'
  }
}))

interface SelectedTooltipProps {
  toggleSelectAll: () => void
  totalCount: number
  selectedCount: number
  onDelete: () => void
}

const SelectedTooltip = ({
  toggleSelectAll,
  totalCount,
  selectedCount,
  onDelete
}: SelectedTooltipProps) => {
  const classes = useStyles()

  return (
    <div className={`shadow-s ${classes.container}`}>
      <div className={classes.text}>
        <Title size={'small'}>
          {selectedCount} of {totalCount} images selected
        </Title>
        <div className={classes.checkbox}>
          <Checkbox
            checked={selectedCount === totalCount}
            onChange={toggleSelectAll}
          />
          <Text size={'xsmall'}>Select all</Text>
        </div>
      </div>
      <Button
        variant={'danger'}
        className={classes.button}
        onClick={onDelete}
        size={'medium'}
      >
        <Delete />
        <Title size={'xsmall'}>Delete</Title>
      </Button>
    </div>
  )
}

export default SelectedTooltip
